import axios from 'axios';
import { reject } from 'lodash';
import getConfig from '../config';
import firebase from '../firebase/FirebaseProvider';

export const getAnonymousToken = async () => {
  const config = getConfig();
  const get_token_url = config.daisy.domain + config.daisy.services.get_twilio_token + '/anonymous';
  const tokenData = await axios.get(get_token_url)
  return (tokenData && tokenData.data) || null;
}

export const getAuthUserChatToken = async () => {
  const promise = new Promise((resolve, reject) => {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        resolve(user);
      } else {
        reject();
      }
    });
  });

  try {
    const currentUser = await promise;
    const idToken = await currentUser.getIdToken();
    const config = getConfig();
    const url = `${config.daisy.domain}${config.daisy.services.get_twilio_token}`;

    const response = await axios.get(url, {
      headers: { 'Authorization': 'Bearer ' + idToken }
    });
    return response && response.data || null;
  } catch (e) {
  }

  return null;
}

